import { iconSizes } from "@/utils/iconProps";

const XpIcon = ({ size = iconSizes.MD_M, ...props }: { size?: number } & React.SVGProps<SVGSVGElement>) => (
    <svg width={size} height={size} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M7.00511 28H4V25.0211L7.65728 21.4058L10.6283 24.3768L7.00511 28Z" fill="#FABE2C" />
        <path d="M7.00511 28.0002L10.6283 24.377L9.12573 22.8745L4 28.0002H7.00511Z" fill="#FD9127" />
        <path d="M22.9621 4L8.23828 19.7008L12.3382 23.7913L28 8.93457V4H22.9621Z" fill="#28C3E1" />
        <path d="M10.2695 21.7289L12.3366 23.7913L27.9984 8.93457V4L10.2695 21.7289Z" fill="#2887C3" />
        <path d="M9.80078 21.236L13.3761 17.6606L14.369 18.6536L10.7937 22.2289L9.80078 21.236Z" fill="#AAEBF0" />
        <path d="M10.2812 21.7155L13.8565 18.1401L14.3701 18.6536L10.7948 22.2291L10.2812 21.7155Z" fill="#28C3E1" />
        <path
            d="M11.5885 26.5474C11.0885 26.5474 10.6184 26.3526 10.2649 25.9991L6.05519 21.7894C5.32535 21.0595 5.32535 19.8721 6.05519 19.1421C6.78509 18.4123 7.9727 18.4122 8.7025 19.1421L12.9122 23.3518C13.2657 23.7053 13.4605 24.1754 13.4605 24.6754C13.4605 25.1754 13.2657 25.6455 12.9122 25.9991C12.5587 26.3526 12.0886 26.5474 11.5885 26.5474Z"
            fill="#FED843"
        />
        <path
            d="M10.7801 21.2202L8.13281 23.8675L10.2645 25.9993C10.6181 26.3529 11.0882 26.5475 11.5881 26.5475C12.0882 26.5475 12.5583 26.3529 12.9118 25.9993C13.2654 25.6457 13.4601 25.1757 13.4601 24.6755C13.4601 24.1755 13.2653 23.7055 12.9118 23.3519L10.7801 21.2202Z"
            fill="#FABE2C"
        />
        <path d="M8.48999 26.5131L5.50663 23.5298L4.50781 24.5171L7.49693 27.5062L8.48999 26.5131Z" fill="#FED843" />
        <path d="M5.99219 26.0022L6.98508 25.0093L8.48741 26.5115L7.49452 27.5045L5.99219 26.0022Z" fill="#FABE2C" />
    </svg>
);

export default XpIcon;
